/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var MicrosCloudFormationStatus;
(function (MicrosCloudFormationStatus) {
    MicrosCloudFormationStatus["CREATE_COMPLETE"] = "CREATE_COMPLETE";
    MicrosCloudFormationStatus["CREATE_FAILED"] = "CREATE_FAILED";
    MicrosCloudFormationStatus["CREATE_IN_PROGRESS"] = "CREATE_IN_PROGRESS";
    MicrosCloudFormationStatus["DELETE_COMPLETE"] = "DELETE_COMPLETE";
    MicrosCloudFormationStatus["DELETE_FAILED"] = "DELETE_FAILED";
    MicrosCloudFormationStatus["DELETE_IN_PROGRESS"] = "DELETE_IN_PROGRESS";
    MicrosCloudFormationStatus["DELETE_SKIPPED"] = "DELETE_SKIPPED";
    MicrosCloudFormationStatus["UPDATE_COMPLETE"] = "UPDATE_COMPLETE";
    MicrosCloudFormationStatus["UPDATE_FAILED"] = "UPDATE_FAILED";
    MicrosCloudFormationStatus["UPDATE_IN_PROGRESS"] = "UPDATE_IN_PROGRESS";
})(MicrosCloudFormationStatus || (MicrosCloudFormationStatus = {}));
export var MicrosDeploymentStatus;
(function (MicrosDeploymentStatus) {
    MicrosDeploymentStatus["CREATE_COMPLETE"] = "CREATE_COMPLETE";
    MicrosDeploymentStatus["CREATE_FAILED"] = "CREATE_FAILED";
    MicrosDeploymentStatus["CREATE_IN_PROGRESS"] = "CREATE_IN_PROGRESS";
    MicrosDeploymentStatus["DELETE_COMPLETE"] = "DELETE_COMPLETE";
    MicrosDeploymentStatus["DELETE_FAILED"] = "DELETE_FAILED";
    MicrosDeploymentStatus["DELETE_IN_PROGRESS"] = "DELETE_IN_PROGRESS";
    MicrosDeploymentStatus["IMPORT_COMPLETE"] = "IMPORT_COMPLETE";
    MicrosDeploymentStatus["IMPORT_IN_PROGRESS"] = "IMPORT_IN_PROGRESS";
    MicrosDeploymentStatus["IMPORT_ROLLBACK_COMPLETE"] = "IMPORT_ROLLBACK_COMPLETE";
    MicrosDeploymentStatus["IMPORT_ROLLBACK_FAILED"] = "IMPORT_ROLLBACK_FAILED";
    MicrosDeploymentStatus["IMPORT_ROLLBACK_IN_PROGRESS"] = "IMPORT_ROLLBACK_IN_PROGRESS";
    MicrosDeploymentStatus["REVIEW_IN_PROGRESS"] = "REVIEW_IN_PROGRESS";
    MicrosDeploymentStatus["ROLLBACK_COMPLETE"] = "ROLLBACK_COMPLETE";
    MicrosDeploymentStatus["ROLLBACK_FAILED"] = "ROLLBACK_FAILED";
    MicrosDeploymentStatus["ROLLBACK_IN_PROGRESS"] = "ROLLBACK_IN_PROGRESS";
    MicrosDeploymentStatus["UPDATE_COMPLETE"] = "UPDATE_COMPLETE";
    MicrosDeploymentStatus["UPDATE_COMPLETE_CLEANUP_IN_PROGRESS"] = "UPDATE_COMPLETE_CLEANUP_IN_PROGRESS";
    MicrosDeploymentStatus["UPDATE_FAILED"] = "UPDATE_FAILED";
    MicrosDeploymentStatus["UPDATE_IN_PROGRESS"] = "UPDATE_IN_PROGRESS";
    MicrosDeploymentStatus["UPDATE_ROLLBACK_COMPLETE"] = "UPDATE_ROLLBACK_COMPLETE";
    MicrosDeploymentStatus["UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS"] = "UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS";
    MicrosDeploymentStatus["UPDATE_ROLLBACK_FAILED"] = "UPDATE_ROLLBACK_FAILED";
    MicrosDeploymentStatus["UPDATE_ROLLBACK_IN_PROGRESS"] = "UPDATE_ROLLBACK_IN_PROGRESS";
})(MicrosDeploymentStatus || (MicrosDeploymentStatus = {}));
export var MicrosEnvironmentFilter;
(function (MicrosEnvironmentFilter) {
    MicrosEnvironmentFilter["ADEV"] = "ADEV";
    MicrosEnvironmentFilter["ADEV_WEST2"] = "ADEV_WEST2";
    MicrosEnvironmentFilter["DDEV"] = "DDEV";
    MicrosEnvironmentFilter["DEV"] = "DEV";
    MicrosEnvironmentFilter["DEV_WEST2"] = "DEV_WEST2";
    MicrosEnvironmentFilter["PDEV_APSE2"] = "PDEV_APSE2";
    MicrosEnvironmentFilter["PDEV_WEST2"] = "PDEV_WEST2";
    MicrosEnvironmentFilter["PROD"] = "PROD";
    MicrosEnvironmentFilter["PROD_APSE"] = "PROD_APSE";
    MicrosEnvironmentFilter["PROD_APSE2"] = "PROD_APSE2";
    MicrosEnvironmentFilter["PROD_CACENTRAL"] = "PROD_CACENTRAL";
    MicrosEnvironmentFilter["PROD_EAST"] = "PROD_EAST";
    MicrosEnvironmentFilter["PROD_EUCENTRAL"] = "PROD_EUCENTRAL";
    MicrosEnvironmentFilter["PROD_EUWEST"] = "PROD_EUWEST";
    MicrosEnvironmentFilter["PROD_WEST"] = "PROD_WEST";
    MicrosEnvironmentFilter["PROD_WEST2"] = "PROD_WEST2";
    MicrosEnvironmentFilter["STAGING"] = "STAGING";
    MicrosEnvironmentFilter["STG_APSE"] = "STG_APSE";
    MicrosEnvironmentFilter["STG_APSE2"] = "STG_APSE2";
    MicrosEnvironmentFilter["STG_CACENTRAL"] = "STG_CACENTRAL";
    MicrosEnvironmentFilter["STG_EAST"] = "STG_EAST";
    MicrosEnvironmentFilter["STG_EUCENTRAL"] = "STG_EUCENTRAL";
    MicrosEnvironmentFilter["STG_EUWEST"] = "STG_EUWEST";
    MicrosEnvironmentFilter["STG_WEST"] = "STG_WEST";
    MicrosEnvironmentFilter["STG_WEST2"] = "STG_WEST2";
})(MicrosEnvironmentFilter || (MicrosEnvironmentFilter = {}));
export var MicrosEnvironmentType;
(function (MicrosEnvironmentType) {
    MicrosEnvironmentType["DEV"] = "DEV";
    MicrosEnvironmentType["PROD"] = "PROD";
    MicrosEnvironmentType["STAGING"] = "STAGING";
})(MicrosEnvironmentType || (MicrosEnvironmentType = {}));
export var MicrosRoutingPolicy;
(function (MicrosRoutingPolicy) {
    MicrosRoutingPolicy["CNAME"] = "CNAME";
    MicrosRoutingPolicy["FAILOVER"] = "FAILOVER";
    MicrosRoutingPolicy["GEOLOCATION"] = "GEOLOCATION";
    MicrosRoutingPolicy["LATENCY"] = "LATENCY";
    MicrosRoutingPolicy["SIMPLE"] = "SIMPLE";
    MicrosRoutingPolicy["WEIGHTED"] = "WEIGHTED";
})(MicrosRoutingPolicy || (MicrosRoutingPolicy = {}));
export var Permission;
(function (Permission) {
    Permission["Admin"] = "Admin";
    Permission["Read"] = "Read";
    Permission["Write"] = "Write";
})(Permission || (Permission = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
